/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module initial
 */

import dropRight from './dropRight';

export default function initial(array) {
  return dropRight(array);
}
